// src/data/works.js
import { clients } from "./clients";


import hayashiseimenjoLp from "../img/work/hayashiseimenjo_lp/thumbnail-main.jpg"
import hayashiseimenjoLpMock from "../img/work/hayashiseimenjo_lp/mockup.jpg"
import hayashiseimenjoLpPc from "../img/work/hayashiseimenjo_lp/pc_design.jpg"
import hayashiseimenjoLpSp from "../img/work/hayashiseimenjo_lp/sp_design.jpg"

import imoriichibaEc from "../img/work/imoriichba_ec/thumbnail-main.jpg";
import imoriichibaEcMock from "../img/work/imoriichba_ec/mockup.jpg";
import imoriichibaEcPc from "../img/work/imoriichba_ec/pc_design.jpg";
import imoriichibaEcSp from "../img/work/imoriichba_ec/sp_design.jpg";

import amesankohLp from "../img/work/amesankoh_lp/thumbnail-main.jpg";
import amesankohLpMock from "../img/work/amesankoh_lp/mockup.jpg";
import amesankohLpSp from "../img/work/amesankoh_lp/sp_design.jpg";

import aquadianaCorporate from "../img/work/aquadiana_corporate/thumbnail-main.jpg";

import artdeliLp from "../img/work/artdeli_lp/thumbnail-main.jpg";
import artdeliLpMock from "../img/work/artdeli_lp/mockup.jpg";
import artdeliLpPc from "../img/work/artdeli_lp/pc_design.jpg";
import artdeliLpSp from "../img/work/artdeli_lp/sp_design.jpg";

import amesankohEc from "../img/work/amesankoh_ec/thumbnail-main.jpg";
import amesankohEcMock from "../img/work/amesankoh_ec/mockup.jpg";
import amesankohEcPc from "../img/work/amesankoh_ec/pc_design.jpg";
import amesankohEcSp from "../img/work/amesankoh_ec/sp_design.jpg";

import transfoodlevEc from "../img/work/transfoodlev_ec/thumbnail-main.jpg";
import transfoodlevEcMock from "../img/work/transfoodlev_ec/mockup.jpg";
import transfoodlevEcPc from "../img/work/transfoodlev_ec/pc_design.jpg";
import transfoodlevEcSp from "../img/work/transfoodlev_ec/sp_design.jpg";

import daeyangEc from "../img/work/daeyang_ec/thumbnail-main.jpg";
import daeyangEcMock from "../img/work/daeyang_ec/mockup.jpg";
import daeyangEcPc from "../img/work/daeyang_ec/pc_design.jpg";
import daeyangEcSp from "../img/work/daeyang_ec/sp_design.jpg";

import japanfesNovelty from "../img/work/japanfes_novelty/thumbnail-main.jpg";
import japanfesNoveltyImg01 from "../img/work/japanfes_novelty/img01.jpg";

import tagawaUniform from "../img/work/tagawa_uniform/thumbnail-main.jpg";
import tagawaUniformImg01 from "../img/work/tagawa_uniform/img01.jpg";

import logotChara from "../img/work/logot_chara/thumbnail-main.jpg";
import logotCharaImg01 from "../img/work/logot_chara/img01.jpg";
import logotCharaImg02 from "../img/work/logot_chara/img02.jpg";
import logotCharaImg03 from "../img/work/logot_chara/img03.jpg";

import daeyangSns from "../img/work/daeyang_sns/thumbnail-main.jpg";

import hayashiseimenjoSns from "../img/work/hayashiseimenjo_sns/thumbnail-main.jpg";

import orenorheingawaBlog from "../img/work/orenorheingawa_blog/thumbnail-main.jpg";

import amesankohjpCorporate from "../img/work/amesankohjp_corporate/thumbnail-main.jpg";
import amesankohjpCorporateMock from "../img/work/amesankohjp_corporate/mockup.jpg";
import amesankohjpCorporatePc from "../img/work/amesankohjp_corporate/pc_design.jpg";
import amesankohjpCorporateSp from "../img/work/amesankohjp_corporate/sp_design.jpg";

import tagawaTote from "../img/work/tagawa_tote/thumbnail-main.jpg";
import tagawaToteImg01 from "../img/work/tagawa_tote/img01.jpg";

import ramennobuUniform from "../img/work/ramennobu_uniform/thumbnail-main.jpg";
import ramennobuUniformImg01 from "../img/work/ramennobu_uniform/img01.jpg";

import eurojcupTote from "../img/work/eurojcup_tote/thumbnail-main.jpg";
import eurojcupToteImg01 from "../img/work/eurojcup_tote/img01.jpg";
import eurojcupToteImg02 from "../img/work/eurojcup_tote/img02.jpg";

import imoriichibaTote from "../img/work/imoriichiba_tote/thumbnail-main.jpg";
import imoriichibaToteImg01 from "../img/work/imoriichiba_tote/img01.jpg";
import imoriichibaToteImg02 from "../img/work/imoriichiba_tote/img02.jpg";
import imoriichibaToteImg03 from "../img/work/imoriichiba_tote/img03.jpg";

import alfaManagementCorporate from "../img/work/alfa-management_corporate/thumbnail-main.jpg";

import marukinkaraageLp from "../img/work/marukinkaraage_lp/thumbnail-main.jpg";
import marukinkaraageLpMock from "../img/work/marukinkaraage_lp/mockup.jpg";
import marukinkaraageLpPc from "../img/work/marukinkaraage_lp/pc_design.jpg";
import marukinkaraageLpSp from "../img/work/marukinkaraage_lp/sp_design.jpg";

import japanfesUniform from "../img/work/japanfes_uniform/thumbnail-main.jpg";
import japanfesUniformImg01 from "../img/work/japanfes_uniform/img01.jpg";
import japanfesUniformImg02 from "../img/work/japanfes_uniform/img02.jpg";

import neotokyocardsEc from "../img/work/neotokyocards_ec/thumbnail-main.jpg";
import neotokyocardsEcMock from "../img/work/neotokyocards_ec/mockup.jpg";
import neotokyocardsEcPc from "../img/work/neotokyocards_ec/pc_design.jpg";
import neotokyocardsEcSp from "../img/work/neotokyocards_ec/sp_design.jpg";

import spogomiUniform from "../img/work/spogomi_uniform/thumbnail-main.jpg";
import spogomiUniformImg01 from "../img/work/spogomi_uniform/img01.jpg";
import spogomiUniformImg02 from "../img/work/spogomi_uniform/img02.jpg";

import toiUniform from "../img/work/toi_uniform/thumbnail-main.jpg";
import toiUniformImg01 from "../img/work/toi_uniform/img01.jpg";
import toiUniformImg02 from "../img/work/toi_uniform/img02.jpg";

import fckreisUniform from "../img/work/fckreis_uniform/thumbnail-main.jpg";
import fckreisUniformImg01 from "../img/work/fckreis_uniform/img01.jpg";

import amesankohProductDaruma from "../img/work/amesankoh_product_daruma/thumbnail-main.jpg";
import amesankohProductDarumaImg01 from "../img/work/amesankoh_product_daruma/img01.jpg";
import amesankohProductDarumaImg02 from "../img/work/amesankoh_product_daruma/img02.jpg";
import amesankohProductDarumaImg03 from "../img/work/amesankoh_product_daruma/img03.jpg";
import amesankohProductDarumaImg04 from "../img/work/amesankoh_product_daruma/img04.jpg";

import beikamochiEc from "../img/work/beikamochi_ec/thumbnail-main.jpg";
import beikamochiEcMock from "../img/work/beikamochi_ec/mockup.jpg";
import beikamochiEcPc from "../img/work/beikamochi_ec/pc_design.jpg";
import beikamochiEcSp from "../img/work/beikamochi_ec/sp_design.jpg";

import beikamochiLp from "../img/work/beikamochi_lp/thumbnail-main.jpg";
import beikamochiLpMock from "../img/work/beikamochi_lp/mockup.jpg";
import beikamochiLpPc from "../img/work/beikamochi_lp/pc_design.jpg";
import beikamochiLpSp from "../img/work/beikamochi_lp/sp_design.jpg";

import beikamochiSns from "../img/work/beikamochi_sns/thumbnail-main.jpg";

import amesankohjpLp from "../img/work/amesankohjp_lp/thumbnail-main.jpg";
import amesankohjpLpMock from "../img/work/amesankohjp_lp/mockup.jpg";
import amesankohjpLpPc from "../img/work/amesankohjp_lp/pc_design.jpg";
import amesankohjpLpSp from "../img/work/amesankohjp_lp/sp_design.jpg";

import beikamochiDisplay from "../img/work/beikamochi_display/thumbnail-main.jpg";
import beikamochiDisplayImg01 from "../img/work/beikamochi_display/img01.jpg";
import beikamochiDisplayImg02 from "../img/work/beikamochi_display/img02.jpg";

import sabigariUniform from "../img/work/sabigari_uniform/thumbnail-main.jpg";
import sabigariUniformImg01 from "../img/work/sabigari_uniform/img01.jpg";
import sabigariUniformImg02 from "../img/work/sabigari_uniform/img02.jpg";

import imoriichibaTote02 from "../img/work/imoriichiba_tote02/thumbnail-main.jpg";
import imoriichibaTote02Img01 from "../img/work/imoriichiba_tote02/img01.jpg";
import imoriichibaTote02Img02 from "../img/work/imoriichiba_tote02/img02.jpg";

import satoFlyer from "../img/work/sato_flyer/thumbnail-main.jpg";

import beikaBnAnuga2025 from "../img/work/beikamochi_bn_anuga_2025/thumbnail-main.jpg";
import beikaBnAnuga2025Img01 from "../img/work/beikamochi_bn_anuga_2025/img01.jpg";
import beikaBnAnuga2025Img02 from "../img/work/beikamochi_bn_anuga_2025/img02.jpg";

import beikaBnCampain2026 from "../img/work/beikamochi_bn_campain_2026/thumbnail-main.jpg";
import beikaBnCampain2026Img01 from "../img/work/beikamochi_bn_campain_2026/img01.jpg";
import beikaBnCampain2026Img02 from "../img/work/beikamochi_bn_campain_2026/img02.jpg";

import beikaBnDokomi2025 from "../img/work/beikamochi_bn_dokomi_2025/thumbnail-main.jpg";

import beikaBnDokomi2026 from "../img/work/beikamochi_bn_dokomi_2026/thumbnail-main.jpg";
import beikaBnDokomi2026Img01 from "../img/work/beikamochi_bn_dokomi_2026/img01.jpg";
import beikaBnDokomi2026Img02 from "../img/work/beikamochi_bn_dokomi_2026/img02.jpg";

import beikaBnIsm2025 from "../img/work/beikamochi_bn_ISM_2025/thumbnail-main.jpg";
import beikaBnIsm2025Img01 from "../img/work/beikamochi_bn_ISM_2025/img01.jpg";

import beikaBnSeekingRetailers from "../img/work/beikamochi_bn_seekingRetailers/thumbnail-main.jpg";
import beikaBnSeekingRetailersImg01 from "../img/work/beikamochi_bn_seekingRetailers/img01.jpg";
import beikaBnSeekingRetailersImg02 from "../img/work/beikamochi_bn_seekingRetailers/img02.jpg";

import beikaBnJapanfes2025 from "../img/work/beikamochi_bn_japanfes_2025/thumbnail-main.jpg";

import beikaBnPopupBerlin2026 from "../img/work/beikamochi_bn_popup_berlin_2026/thumbnail-main.jpg";

import beikaBnPopupHanaro2025 from "../img/work/beikamochi_bn_popup_hanaro_2025/thumbnail-main.jpg";

import beikaBnPopupPari2025 from "../img/work/beikamochi_bn_popup_pari_2025/thumbnail-main.jpg";

import mikanEc from "../img/work/mikan_ec/thumbnail-main.jpg";
import mikanEcMock from "../img/work/mikan_ec/mockup.jpg";
import mikanEcPc from "../img/work/mikan_ec/pc_design.jpg";
import mikanEcSp from "../img/work/mikan_ec/sp_design.jpg";

import satoMovie from "../img/work/sato_movie/thumbnail-main.jpg";
import satoMovie01 from "../img/work/sato_movie/movie01.mp4";
import satoPoster from "../img/work/sato_movie/poster.jpg";

import satoBn from "../img/work/sato_banner/thumbnail-main.jpg";

export const works = [
    // {
    //     slug: "artdeliLp",
    //     category: "LP",
    //     clientId: "hayashiseimenjo",
    //     thumbnail: artdeliLp,
    //     title: {
    //         ja: "Art Deli | LP",
    //         en: "Art Deli | LP",
    //     },
    //     ctas: [
    //         {
    //             label: { ja: "Webサイトを見る", en: "View Website" },
    //             url: "https://artdeli.info/",
    //         },
    //     ],
    //     ctas: [
    //         {
    //             label: { ja: "Instagramを見る", en: "View Instagram" },
    //             url: "https://www.instagram.com/daeyang_dusseldorf/?hl=en",
    //         },
    //     ],
    //     client: {
    //         name: {
    //             ja: "Art Deli",
    //             en: "Art Deli",
    //         },
    //     },
    //     industryTags: ["interior", "artSales"],
    //     company: {
    //         country: "japan",
    //     },
    //     overview: {
    //         ja: "ペットの写真をもとにしたオリジナルアートボードを制作・販売する企業。",
    //         en: "A company that creates and sells custom art boards based on pet photos.",
    //     },
    //     serviceTags: ["lp", "translation", "localization"],
    //     target: {
    //         regions: ["europe"],
    //         countries: [],
    //     },
    //     purposeTags: ["inquiry", "sales"],
    //     requestBackground: {
    //         ja: "海外で自社の事業のアピールと受注を増やしたい。",
    //         en: "The client wanted to promote their business overseas and increase orders.",
    //     },
    //     release: {
    //         ja: "2024年11月",
    //         en: "November 2024",
    //     },
    //     website: "https://logot.de/",
    //     images: [artdeliLpMock],
    //     webImages: {
    //         pc: artdeliLpPc,
    //         sp: artdeliLpSp,
    //     },
    //      videos: [
    //     {
    //         src: satoMovie01,
    //         isPortrait: true,
    //     },
    //      ],
    // },
    {
        slug: "satoBn",
        category: "Banner",
        clientId: "satoseiyaku",
        thumbnail: satoBn,
        title: {
            ja: "佐藤製薬 | バナー",
            en: "Sato Pharmaceutical Co., Ltd. | Banner",
        },
        serviceTags: ["banner", "translation", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "オンライン薬局 apodiscounter 掲載用バナーの作成",
            en: "Banner for online pharmacy apodiscounter.",
        },
        release: {
            ja: "2026年6月",
            en: "June 2026",
        },
    },
    {
        slug: "satoMovie",
        category: "Movie",
        clientId: "satoseiyaku",
        thumbnail: satoMovie,
        title: {
            ja: "佐藤製薬 | 動画",
            en: "Sato Pharmaceutical Co., Ltd. | Movie",
        },
        mainVideo: {
            src: satoMovie01,
            isPortrait: true,
            poster: satoPoster,
        },
        serviceTags: ["movie", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "広告用の動画の制作。",
            en: "Production of promotional videos.",
        },
        release: {
            ja: "2026年6月",
            en: "June 2026",
        },
    },
    {
        slug: "mikanEc",
        category: "EC",
        clientId: "mikan",
        thumbnail: mikanEc,
        title: {
            ja: "Mikan | ECサイト",
            en: "Mikan | EC Website",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://mikan-ec.com/",
            },
        ],
        serviceTags: ["ec", "translation", "localization"],
        purposeTags: ["brand", "sales", "inquiry"],
        requestBackground: {
            ja: "日本商品の欧州市場展開を支援する越境ECサービスとして、Mikanのサービス内容やブランドの世界観を分かりやすく伝える。<br>海外販売には、言語対応や現地向けの商品説明、物流、決済、顧客対応など多くのハードルがあります。そこで、日本の事業者に対しては海外進出への安心感を、欧州の消費者に対しては日本商品との出会いを提供できるよう、Mikanの目的や強みを整理し、信頼感のある形で発信することを目指しました。",
            en: "As a cross-border e-commerce service that supports the expansion of Japanese products into the European market, Mikan needed to clearly communicate its service content and brand worldview.<br>Overseas sales involve many challenges, including language support, product descriptions tailored to local markets, logistics, payment systems, and customer service. Therefore, the goal was to organize and present Mikan’s purpose and strengths in a trustworthy way, so that Japanese businesses could feel confident about entering overseas markets, while European consumers could discover new Japanese products.",
        },
        release: {
            ja: "2026年6月",
            en: "June 2026",
        },
        images: [mikanEcMock],
        webImages: {
            pc: mikanEcPc,
            sp: mikanEcSp,
        },
    },
    {
        slug: "beikaBnDokomi2026",
        category: "Banner",
        clientId: "beikamochi",
        thumbnail: beikaBnDokomi2026,
        title: {
            ja: "Beika Mochi | バナー",
            en: "Beika Mochi | Banner",
        },
        serviceTags: ["banner", "translation", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "ドイツで開催されたアニメイベントDoKomiへの出展を告知するバナー",
            en: "Promotional banner announcing Beika Mochi's participation in the anime event DoKomi held in Germany.",
        },
        release: {
            ja: "2026年5月",
            en: "May 2026",
        },
        images: [beikaBnDokomi2026Img01, beikaBnDokomi2026Img02],
    },
    {
        slug: "beikaBnPopupBerlin2026",
        category: "Banner",
        clientId: "beikamochi",
        thumbnail: beikaBnPopupBerlin2026,
        title: {
            ja: "Beika Mochi | バナー",
            en: "Beika Mochi | Banner",
        },
        serviceTags: ["banner", "translation", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "ポップアップの告知バナー",
            en: "Promotional banner for a pop-up event.",
        },
        release: {
            ja: "2026年4月",
            en: "April 2026",
        },
    },
    {
        slug: "beikaBnCampain2026",
        category: "Banner",
        clientId: "beikamochi",
        thumbnail: beikaBnCampain2026,
        title: {
            ja: "Beika Mochi | バナー",
            en: "Beika Mochi | Banner",
        },
        serviceTags: ["banner", "translation", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "オンライン販売開始記念イベントの認知拡大を目的としたバナー",
            en: "Promotional banner created to raise awareness of a launch event celebrating the start of online sales.",
        },
        release: {
            ja: "2026年2月",
            en: "February 2026",
        },
        images: [beikaBnCampain2026Img01, beikaBnCampain2026Img02],
    },
    {
        slug: "beikaBnIsm2025",
        category: "Banner",
        clientId: "beikamochi",
        thumbnail: beikaBnIsm2025,
        title: {
            ja: "Beika Mochi | バナー",
            en: "Beika Mochi | Banner",
        },
        serviceTags: ["banner", "translation", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "食品展示会のISMに出展する告知バナー",
            en: "Promotional banner announcing Beika Mochi's participation in ISM, an international food trade fair.",
        },
        release: {
            ja: "2026年1月",
            en: "January 2026",
        },
        images: [beikaBnIsm2025Img01],
    },
    {
        slug: "beikaBnPopupPari2025",
        category: "Banner",
        clientId: "beikamochi",
        thumbnail: beikaBnPopupPari2025,
        title: {
            ja: "Beika Mochi | バナー",
            en: "Beika Mochi | Banner",
        },
        serviceTags: ["banner", "translation", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "パリでポップアップをする告知バナー",
            en: "Promotional banner for a pop-up event in Paris.",
        },
        release: {
            ja: "2025年11月",
            en: "November 2025",
        },
    },
    {
        slug: "beikaBnAnuga2025",
        category: "Banner",
        clientId: "beikamochi",
        thumbnail: beikaBnAnuga2025,
        title: {
            ja: "Beika Mochi | バナー",
            en: "Beika Mochi | Banner",
        },
        serviceTags: ["banner", "translation", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "ドイツの食品展示会のAnugaに出展する告知バナー",
            en: "Promotional banner announcing Beika Mochi's participation in Anuga, a food trade fair in Germany.",
        },
        release: {
            ja: "2025年9月",
            en: "September 2025",
        },
        images: [beikaBnAnuga2025Img01, beikaBnAnuga2025Img02],
    },
    {
        slug: "beikaBnPopupHanaro2025",
        category: "Banner",
        clientId: "beikamochi",
        thumbnail: beikaBnPopupHanaro2025,
        title: {
            ja: "Beika Mochi | バナー",
            en: "Beika Mochi | Banner",
        },
        serviceTags: ["banner", "translation", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "スーパーでのポップアップの告知バナー",
            en: "Promotional banner for a pop-up event at a supermarket.",
        },
        release: {
            ja: "2025年8月",
            en: "August 2025",
        },
    },
    {
        slug: "beikaBnSeekingRetailers",
        category: "Banner",
        clientId: "beikamochi",
        thumbnail: beikaBnSeekingRetailers,
        title: {
            ja: "Beika Mochi | バナー",
            en: "Beika Mochi | Banner",
        },
        serviceTags: ["banner", "translation", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "取扱店舗募集のバナー",
            en: "Banner for recruiting retail partners.",
        },
        release: {
            ja: "2025年7月",
            en: "July 2025",
        },
        images: [beikaBnSeekingRetailersImg01, beikaBnSeekingRetailersImg02],
    },
    {
        slug: "beikaBnDokomi2025",
        category: "Banner",
        clientId: "beikamochi",
        thumbnail: beikaBnDokomi2025,
        title: {
            ja: "Beika Mochi | バナー",
            en: "Beika Mochi | Banner",
        },
        serviceTags: ["banner", "translation", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "ドイツで開催されたアニメイベントDoKomiへの出展を告知するバナー",
            en: "Promotional banner announcing Beika Mochi's participation in the anime event DoKomi held in Germany.",
        },
        release: {
            ja: "2025年5月",
            en: "May 2025",
        },
    },
    {
        slug: "beikaBnJapanfes2025",
        category: "Banner",
        clientId: "beikamochi",
        thumbnail: beikaBnJapanfes2025,
        title: {
            ja: "Beika Mochi | バナー",
            en: "Beika Mochi | Banner",
        },
        serviceTags: ["banner", "translation", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "ベルギーで開催されたJapan Fesに出展する告知バナー",
            en: "Promotional banner for an exhibit at Japan Fes in Belgium.",
        },
        release: {
            ja: "2025年4月",
            en: "April 2025",
        },
    },
    {
        slug: "satoFlyer",
        category: "Flyer",
        clientId: "satoseiyaku",
        thumbnail: satoFlyer,
        title: {
            ja: "佐藤製薬 | チラシ",
            en: "Sato Pharmaceutical Co., Ltd. | Flyer",
        },
        serviceTags: ["flyer"],
        purposeTags: ["sales"],
        requestBackground: {
            ja: "新商品「ユンケル（カフェインゼロ）」の欧州市場投入にあたり、認知拡大とターゲット層への適切な訴求を目的としたプロモーション強化が必要となったため",
            en: "With the launch of the new product “Yunker (Caffeine-Free)” in the European market, there was a need to strengthen promotional efforts in order to increase brand awareness and effectively reach the target audience.",
        },
        release: {
            ja: "2026年4月",
            en: "April 2026",
        },
    },
    {
        slug: "imoriichibaTote02",
        category: "Product",
        clientId: "imoriichiba",
        thumbnail: imoriichibaTote02,
        title: {
            ja: "IMORI ICHIBA | トートバッグ",
            en: "IMORI ICHIBA | Totebag",
        },
        serviceTags: ["product", "print"],
        purposeTags: ["brand"],
        requestBackground: {
            ja: "ブランド認知向上と企業アピールを目的としたトートバッグを制作したい。",
            en: "The client wanted to create tote bags to enhance brand awareness and promote the company.",
        },
        release: {
            ja: "2026年3月",
            en: "March 2026",
        },
        images: [imoriichibaTote02Img01, imoriichibaTote02Img02],
    },
    {
        slug: "sabigariUniform",
        category: "Uniform",
        thumbnail: sabigariUniform,
        title: {
            ja: "SABI & GARI | ユニフォーム",
            en: "SABI & GARI | Uniform",
        },
        client: {
            name: {
                ja: "SABI & GARI",
                en: "SABI & GARI",
            },
        },
        industryTags: ["restaurant"],
        company: {
            country: "germany",
        },
        overview: {
            ja: "2018年4月デュッセルドルフ、オーバーカッセルに寿司居酒屋SABI&GARI開店。伝統的な日本料理を基本にモダンな食材や盛り付けも取り入れ、美味しいだけでなく驚きや楽しさを味わって頂き、お客様に心地よい空間を提供",
            en: "In April 2018, the sushi izakaya SABI & GARI opened in Oberkassel, Düsseldorf. Based on traditional Japanese cuisine, the restaurant incorporates modern ingredients and presentation. In addition to serving delicious food, it aims to provide guests with a sense of surprise and enjoyment, while offering a comfortable and welcoming atmosphere.",
        },
        serviceTags: ["uniform"],
        target: {
            regions: [],
            countries: ["germany"],
        },
        purposeTags: ["brand"],
        requestBackground: {
            ja: "酒の試飲会イベントや寿司ケータリングの際に着用できる、ブランドを表現したユニフォームが必要だったため。",
            en: "A uniform that expresses the brand was needed to be worn during sake tasting events and sushi catering services.",
        },
        release: {
            ja: "2026年1月",
            en: "January 2026",
        },
        images: [sabigariUniformImg01, sabigariUniformImg02],
    },
    {
        slug: "beikamochiDisplay",
        category: "Display",
        clientId: "beikamochi",
        thumbnail: beikamochiDisplay,
        title: {
            ja: "Beika Mochi | 什器",
            en: "Beika Mochi | Display Fixture",
        },
        serviceTags: ["display", "translation", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "小売店の棚における商品陳列を整え、視認性を高めるため。ブランドイメージを向上させ、販売促進につなげる目的があった。",
            en: "To organize product displays on retail shelves and improve visibility. The goal was to enhance the brand image and support sales promotion.",
        },
        release: {
            ja: "2026年2月",
            en: "February 2026",
        },
        images: [beikamochiDisplayImg01, beikamochiDisplayImg02],
    },
    {
        slug: "amesankohjpLp",
        category: "Corporate",
        thumbnail: amesankohjpLp,
        title: {
            ja: "Amesankoh | LP",
            en: "Amesankoh | LP",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://www.amesankoh.co.jp/ekkyyo",
            },
        ],
        client: {
            name: {
                ja: "Amesankoh",
                en: "Amesankoh",
            },
        },
        industryTags: ["it", "consulting"],
        company: { country: "japan" },
        overview: {
            ja: "日本のデロイト出身者が創業のコンサル会社。",
            en: "A consulting firm founded by former Deloitte Japan employees.",
        },
        serviceTags: ["lp"],
        target: { regions: [], countries: ["japan"] },
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "Amesankohとして越境事業を本格的に開始するにあたり、LPを制作し、海外向けの問い合わせ増加を目的としていた。",
            en: "As Amesankoh began its cross-border business in earnest, it created a landing page with the aim of increasing inquiries from overseas.",
        },
        release: {
            ja: "2025年10月",
            en: "October 2025",
        },
        website: "https://www.amesankoh.co.jp/",
        images: [amesankohjpLpMock],
        webImages: {
            pc: amesankohjpLpPc,
            sp: amesankohjpLpSp,
        },
    },
    {
        slug: "beikamochiSns",
        category: "SNS",
        clientId: "beikamochi",
        thumbnail: beikamochiSns,
        title: {
            ja: "Beika Mochi | SNS運用",
            en: "Beika Mochi | Social Media Marketing",
        },
        ctas: [
            {
                label: { ja: "Instagramを見る", en: "View Instagram" },
                url: "https://www.instagram.com/beika_mochi_eu/",
            },
        ],
        serviceTags: ["sns", "translation", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "商品認知向上を目的とし、写真撮影から投稿までを一括で管理してほしいという要望があった。Instagram上で商品と日本文化、欧米文化を組み合わせたブランディングを行うため。",
            en: "The objective was to increase product awareness, with a request to manage the entire process from photo shooting to posting in an integrated manner. The goal was to build branding on Instagram by combining the product with elements of Japanese culture and Western culture.",
        },
        release: {
            ja: "2024年12月",
            en: "December 2024",
        },
    },
    {
        slug: "beikamochiLp",
        category: "LP",
        clientId: "beikamochi",
        thumbnail: beikamochiLp,
        title: {
            ja: "Beika Mochi | LP",
            en: "Beika Mochi | LP",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://beikamochi.eu/pages/lp",
            },
        ],
        serviceTags: ["lp", "translation", "localization"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "商品の魅力やブランドイメージの向上を目的とし、特に5商品にフォーカスした訴求を行うため。動画や詳細な商品説明をLP内に盛り込みたいという要望があった。",
            en: "The goal was to enhance the product appeal and overall brand image, with a particular focus on promoting five key products. There was a request to incorporate videos and detailed product descriptions into the landing page.",
        },
        release: {
            ja: "2024年12月",
            en: "December 2024",
        },
        images: [beikamochiLpMock],
        webImages: {
            pc: beikamochiLpPc,
            sp: beikamochiLpSp,
        },
    },
    {
        slug: "beikamochiEc",
        category: "EC",
        clientId: "beikamochi",
        thumbnail: beikamochiEc,
        title: {
            ja: "Beika Mochi | ECサイト",
            en: "Beika Mochi | EC Website",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://beikamochi.eu/",
            },
        ],
        serviceTags: ["ec", "shopify", "translation", "localization", "emailSales", "exhibitionAgency"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "Shopifyを活用し、商品イメージの訴求を行うと同時に、ECサイトとしての販売機能を強化するため。",
            en: "To leverage Shopify to effectively communicate the product’s visual identity while strengthening the e-commerce site’s sales functionality.",
        },
        release: {
            ja: "2025年4月",
            en: "April 2025",
        },
        images: [beikamochiEcMock],
        webImages: {
            pc: beikamochiEcPc,
            sp: beikamochiEcSp,
        },
    },
    {
        slug: "hayashiseimenjoLp",
        category: "LP",
        clientId: "hayashiseimenjo",
        thumbnail: hayashiseimenjoLp,
        title: {
            ja: "林製麺所 | LP",
            en: "Hayashi Seimenjo | LP",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://hayashi-seimen.eu/",
            },
        ],
        serviceTags: ["lp", "translation", "localization", "emailSales"],
        purposeTags: ["inquiry"],
        requestBackground: {
            ja: "ドイツをはじめとするヨーロッパ各国のレストランやカフェ向けに、麺の卸売業務を展開したい。",
            en: "Wishing to expand wholesale noodle sales to restaurants and cafes in Germany and other European countries.",
        },
        release: {
            ja: "2024年11月",
            en: "November 2024",
        },
        images: [hayashiseimenjoLpMock],
        webImages: {
            pc: hayashiseimenjoLpPc,
            sp: hayashiseimenjoLpSp,
        },
    },

    {
        slug: "imoriichibaEc",
        category: "EC",
        clientId: "imoriichiba",
        thumbnail: imoriichibaEc,
        title: {
            ja: "IMORI ICHIBA | ECサイト",
            en: "IMORI ICHIBA | EC Website",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://www.iimori-ichiba.com/ja",
            },
        ],
        serviceTags: ["ec", "shopify"],
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "オンラインショップの立ち上げと、自店のImbiss（イートイン）をアピールしたい。",
            en: "The client wanted to launch an online shop and promote their in-store Imbiss (eat-in) section.",
        },
        release: {
            ja: "2024年5月",
            en: "May 2024",
        },
        images: [imoriichibaEcMock],
        webImages: {
            pc: imoriichibaEcPc,
            sp: imoriichibaEcSp,
        },
    },

    {
        slug: "amesankohLp",
        category: "LP",
        clientId: "amesankoh",
        thumbnail: amesankohLp,
        title: {
            ja: "Amesankoh | LP",
            en: "Amesankoh | LP",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://amesankoh-ogata.netlify.app/",
            },
        ],
        serviceTags: ["lp", "translation"],
        purposeTags: ["brand", "inquiry", "sales"],
        requestBackground: {
            ja: "デザイナーコラボの商品のアピールをしたい。",
            en: "The client wanted to promote products created in collaboration with designers.",
        },
        release: {
            ja: "2024年11月",
            en: "November 2024",
        },
        images: [amesankohLpMock],
        webImages: {
            sp: amesankohLpSp,
        },
    },

    {
        slug: "aquadianaCorporate",
        category: "Corporate",
        thumbnail: aquadianaCorporate,
        title: {
            ja: "AQUA DIANA | コーポレートサイト",
            en: "AQUA DIANA | Corporate Website",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://aquadiana.de/",
            },
        ],
        client: {
            name: {
                ja: "AQUA DIANA",
                en: "AQUA DIANA",
            },
        },
        industryTags: ["service"],
        company: {
            country: "germany",
        },
        overview: {
            ja: "ドイツの浄水器を取り扱う企業。",
            en: "A company that handles water purifiers in Germany.",
        },
        serviceTags: ["corporate", "emailSales"],
        target: {
            regions: [],
            countries: ["germany"],
        },
        purposeTags: ["inquiry", "sales"],
        requestBackground: {
            ja: "商品説明の掲載と問い合わせ窓口のため、コーポレートサイトを立ち上げたい。",
            en: "The client wanted to launch a corporate website to provide product descriptions and receive inquiries.",
        },
        release: {
            ja: "2023年8月",
            en: "August 2023",
        },
    },

    {
        slug: "artdeliLp",
        category: "LP",
        thumbnail: artdeliLp,
        title: {
            ja: "Art Deli | LP",
            en: "Art Deli | LP",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://artdeli.info/",
            },
        ],
        client: {
            name: {
                ja: "Art Deli",
                en: "Art Deli",
            },
        },
        industryTags: ["interior", "artSales"],
        company: {
            country: "japan",
        },
        overview: {
            ja: "ペットの写真をもとにしたオリジナルアートボードを制作・販売する企業。",
            en: "A company that creates and sells custom art boards based on pet photos.",
        },
        serviceTags: ["lp", "translation", "localization"],
        target: {
            regions: ["europe"],
            countries: [],
        },
        purposeTags: ["inquiry", "sales"],
        requestBackground: {
            ja: "海外で自社の事業のアピールと受注を増やしたい。",
            en: "The client wanted to promote their business overseas and increase orders.",
        },
        release: {
            ja: "2024年11月",
            en: "November 2024",
        },
        images: [artdeliLpMock],
        webImages: {
            pc: artdeliLpPc,
            sp: artdeliLpSp,
        },
    },

    {
        slug: "amesankohEc",
        category: "EC",
        clientId: "amesankoh",
        thumbnail: amesankohEc,
        title: {
            ja: "Amesankoh | ECサイト",
            en: "Amesankoh | EC Website",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://amesankoh.com/",
            },
        ],
        serviceTags: ["ec", "shopify"],
        purposeTags: ["sales"],
        requestBackground: {
            ja: "日本の文化をモチーフとした商品をドイツに広めたい。",
            en: "The client wanted to spread products inspired by Japanese culture in Germany.",
        },
        release: {
            ja: "2022年8月",
            en: "August 2022",
        },
        images: [amesankohEcMock],
        webImages: {
            pc: amesankohEcPc,
            sp: amesankohEcSp,
        },
    },

    {
        slug: "transfoodlevEc",
        category: "EC",
        thumbnail: transfoodlevEc,
        title: {
            ja: "TRANS FOOD LEV | ECサイト",
            en: "TRANS FOOD LEV | EC Website",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://transfoodlev.com/",
            },
        ],
        client: {
            name: {
                ja: "TRANS FOOD LEV",
                en: "TRANS FOOD LEV",
            },
        },
        industryTags: ["food"],
        company: {
            country: "germany",
        },
        overview: {
            ja: "ドイツのレバークーゼンにあるアジア系小売店。",
            en: "An Asian retail store in Leverkusen, Germany.",
        },
        serviceTags: ["ec", "shopify"],
        target: {
            regions: ["europe"],
            countries: [],
        },
        purposeTags: ["sales"],
        requestBackground: {
            ja: "オンラインショップを立ち上げたい。",
            en: "The client wanted to launch an online shop.",
        },
        release: {
            ja: "2024年9月",
            en: "September 2024",
        },
        website: "https://transfoodlev.com/",
        images: [transfoodlevEcMock],
        webImages: {
            pc: transfoodlevEcPc,
            sp: transfoodlevEcSp,
        },
    },

    {
        slug: "daeyangEc",
        category: "EC",
        clientId: "daeyang",
        thumbnail: daeyangEc,
        title: {
            ja: "Dae-Yang GmbH | ECサイト",
            en: "Dae-Yang GmbH | EC Website",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://dae-yang.online/",
            },
        ],
        serviceTags: ["ec", "shopify"],
        purposeTags: ["sales"],
        requestBackground: {
            ja: "オンラインショップを立ち上げたい。",
            en: "The client wanted to launch an online shop.",
        },
        release: {
            ja: "2022年8月",
            en: "August 2022",
        },
        images: [daeyangEcMock],
        webImages: {
            pc: daeyangEcPc,
            sp: daeyangEcSp,
        },
    },

    {
        slug: "japanfesNovelty",
        category: "Novelty",
        clientId: "japanfes",
        thumbnail: japanfesNovelty,
        title: {
            ja: "Japan Fes | ノベルティ",
            en: "Japan Fes | Novelty",
        },
        serviceTags: ["novelty", "print"],
        purposeTags: ["brand"],
        release: {
            ja: "2024年4月",
            en: "April 2024",
        },
        images: [japanfesNoveltyImg01],
    },

    {
        slug: "tagawaUniform",
        category: "Uniform",
        clientId: "tagawa",
        thumbnail: tagawaUniform,
        title: {
            ja: "田川 | ユニフォーム",
            en: "Tagawa | Uniform",
        },
        serviceTags: ["uniform", "print"],
        purposeTags: ["brand"],
        requestBackground: {
            ja: "スタッフ用のユニフォームを作成して、ブランドイメージの向上をはかりたい。",
            en: "The client wanted to create staff uniforms to enhance the brand image.",
        },
        release: {
            ja: "2024年9月",
            en: "September 2024",
        },
        images: [tagawaUniformImg01],
    },

    {
        slug: "logotChara",
        category: "Character",
        thumbnail: logotChara,
        title: {
            ja: "LOGOT | キャラクター",
            en: "LOGOT | Character",
        },
        client: {
            name: {
                ja: "LOGOT",
                en: "LOGOT",
            },
        },
        industryTags: ["it", "consulting"],
        company: {
            country: "germany",
        },
        overview: {
            ja: "ドイツのコンサルティング・IT企業。",
            en: "A consulting and IT company in Germany.",
        },
        serviceTags: ["character"],
        target: {
            regions: ["europe"],
            countries: [],
        },
        purposeTags: ["brand"],
        requestBackground: {
            ja: "ノベルティを作成するためのキャラクターが欲しい",
            en: "The client wanted a character to create novelty items.",
        },
        release: {
            ja: "2025年1月",
            en: "January 2025",
        },
        website: "https://logot.de/",
        images: [logotCharaImg01, logotCharaImg02, logotCharaImg03],
    },

    {
        slug: "daeyangSns",
        category: "SNS",
        clientId: "daeyang",
        thumbnail: daeyangSns,
        title: {
            ja: "Dae-Yang GmbH | SNS運用",
            en: "Dae-Yang GmbH | Social Media Marketing",
        },
        ctas: [
            {
                label: { ja: "Instagramを見る", en: "View Instagram" },
                url: "https://www.instagram.com/daeyang_dusseldorf/?hl=en",
            },
        ],
        serviceTags: ["sns", "translation", "localization"],
        purposeTags: ["sales"],
        requestBackground: {
            ja: "自社の事業をSNSでアピールしたり、日本食について情報を発信したい。",
            en: "The client wanted to promote their company on social media and share information about Japanese food.",
        },
        release: {
            ja: "2022年8月",
            en: "August 2022",
        },
    },

    {
        slug: "amesankohProductDaruma",
        category: "Product",
        clientId: "amesankoh",
        thumbnail: amesankohProductDaruma,
        title: {
            ja: "Amesankoh | 商品制作",
            en: "Amesankoh | Product Development",
        },
        serviceTags: ["product", "print"],
        purposeTags: ["brand"],
        requestBackground: {
            ja: "Amesankohは、アパレル商品のデザイン制作から印刷までをLOGOTへ一括で依頼しました。特に今回は、少ロットでの生産を希望しつつ、デザインの種類を増やすことで販売時の新商品展開の幅を広げたいという背景がありました。デザイン面では、Darumaを単にシンプルに表現するのではなく、多様な表情・スタイルのDarumaを見せることで、シリーズとしての広がりや今後の展開イメージを伝えられるビジュアルをLOGOTに依頼しています。",
            en: "Amesankoh entrusted LOGOT with the entire process—from apparel design to printing. For this project, Amesankoh aimed to produce items in small quantities while expanding the range of designs in order to increase flexibility in launching new products at the point of sale. In terms of design, rather than depicting Daruma in a single, simple style, Amesankoh requested visuals that showcase a variety of Daruma expressions and styles. This approach was intended to communicate the breadth of the series and convey a clear vision for future developments, all of which were carefully designed by LOGOT.",
        },
        images: [
            amesankohProductDarumaImg01,
            amesankohProductDarumaImg02,
            amesankohProductDarumaImg03,
            amesankohProductDarumaImg04,
        ],
    },

    {
        slug: "toiUniform",
        category: "Uniform",
        thumbnail: toiUniform,
        title: {
            ja: "Toi Izakaya | ユニフォーム",
            en: "Toi Izakaya | Uniform",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "",
            },
        ],
        industryTags: ["restaurant"],
        company: {
            country: "germany",
        },
        overview: {
            ja: "デュッセルドルフを拠点とする、創作和食とビーガンをテーマに食を提供する人気居酒屋。",
            en: "A popular izakaya in Düsseldorf offering creative Japanese cuisine and natural wines.",
        },
        serviceTags: ["uniform", "print"],
        target: {
            regions: [],
            countries: ["germany"],
        },
        purposeTags: ["brand"],
        requestBackground: {
            ja: "お店の雰囲気やブランドイメージに合わせた統一感のあるユニフォームを制作したいというご要望により、転写プリントのTシャツの提案・制作。",
            en: "The client wanted cohesive uniforms that matched the restaurant’s atmosphere and brand image. We proposed and produced T-shirts with transfer printing.",
        },
        release: {
            ja: "2025年6月",
            en: "June 2025",
        },
        website: "https://toiizakaya.com/",
        images: [toiUniformImg01, toiUniformImg02],
    },

    {
        slug: "fckreisUniform",
        category: "Uniform",
        thumbnail: fckreisUniform,
        title: {
            ja: "FC KREIS | ユニフォーム",
            en: "FC KREIS | Uniform",
        },
        client: {
            name: {
                ja: "FC KREIS",
                en: "FC KREIS",
            },
        },
        industryTags: ["sports"],
        company: {
            country: "germany",
        },
        overview: {
            ja: "CfR Links Düsseldorfのグループで活動するサッカーチーム。",
            en: "A football team based at the CfR Links Düsseldorf grounds.",
        },
        serviceTags: ["uniform", "print"],
        target: {
            regions: [],
            countries: ["germany"],
        },
        purposeTags: ["brand"],
        requestBackground: {
            ja: "試合用のサッカーユニフォームの制作につき、エンブレムの作成したい。",
            en: "They wanted to create a custom emblem for the design of their match-day football uniforms.",
        },
        images: [fckreisUniformImg01],
    },

    {
        slug: "spogomiUniform",
        category: "Uniform",
        thumbnail: spogomiUniform,
        title: {
            ja: "SpoGomi | ユニフォーム",
            en: "SpoGomi | Uniform",
        },
        client: {
            name: {
                ja: "SpoGomi",
                en: "SpoGomi",
            },
        },
        industryTags: ["event"],
        company: {
            country: "germany",
        },
        overview: {
            ja: "日本を拠点に、地域社会と連携した環境啓発イベント「SpoGomi World Cup」の開催・運営を行う。",
            en: "Based in Japan, SpoGomi organizes the \"SpoGomi World Cup\", an environmental awareness event in cooperation with local communities.",
        },
        serviceTags: ["uniform", "print"],
        target: {
            regions: [],
            countries: ["germany"],
        },
        purposeTags: ["brand"],
        requestBackground: {
            ja: "ドイツ大会開催に伴い、参加者用のユニフォームを制作。大会およびスポンサーのアピールを目的に、ロゴのプリントを希望。また、役職が一目でわかるようなデザインも要望されました。",
            en: "With the upcoming tournament in Germany, we were commissioned to produce uniforms for the participants. The client requested logo printing to promote both the event and its sponsors. They also asked for a design that would clearly indicate each wearer’s role at a glance.",
        },
        release: {
            ja: "2025年6月",
            en: "June 2025",
        },
        website: "https://spogomigermany.jimdofree.com/",
        images: [spogomiUniformImg01, spogomiUniformImg02],
    },

    {
        slug: "neotokyocardsEc",
        category: "EC",
        thumbnail: neotokyocardsEc,
        title: {
            ja: "Neo Tokyo Cards | ECサイト",
            en: "Neo Tokyo Cards | EC Website",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://neotokyocards.com/",
            },
        ],
        client: {
            name: {
                ja: "株式会社ビジョン",
                en: "Bicion Co., Ltd.",
            },
        },
        industryTags: ["tradingCard"],
        company: {
            country: "japan",
        },
        overview: {
            ja: "日本語版のポケモンカードを、ドイツを中心としたヨーロッパ諸国向けに販売しているオンラインショップ。",
            en: "An online shop that sells Japanese Pokémon cards to European countries, primarily focusing on Germany.",
        },
        serviceTags: ["ec", "shopify"],
        target: {
            regions: ["europe"],
            countries: [],
        },
        purposeTags: ["brand", "sales"],
        requestBackground: {
            ja: "コレクター向けに日本語版のポケモンカードを海外で販売したい。",
            en: "We aim to offer Japanese Pokémon cards for collectors outside Japan.",
        },
        release: {
            ja: "2025年5月",
            en: "May 2025",
        },
        images: [neotokyocardsEcMock],
        webImages: {
            pc: neotokyocardsEcPc,
            sp: neotokyocardsEcSp,
        },
    },

    {
        slug: "japanfesUniform",
        category: "Uniform",
        clientId: "japanfes",
        thumbnail: japanfesUniform,
        title: { ja: "Japan Fes | ユニフォーム", en: "Japan Fes | Uniform" },
        serviceTags: ["uniform", "print"],
        purposeTags: ["brand"],
        requestBackground: {
            ja: "イベント運営スタッフ用のスウェットを制作したい。",
            en: "The client wanted sweatshirts for event staff.",
        },
        release: {
            ja: "2025年4月",
            en: "April 2025",
        },
        images: [japanfesUniformImg01, japanfesUniformImg02],
    },

    {
        slug: "hayashiseimenjoSns",
        category: "SNS",
        clientId: "hayashiseimenjo",
        thumbnail: hayashiseimenjoSns,
        title: {
            ja: "林製麺所 | SNS運用",
            en: "Hayashi Seimen Europe | Social Media Marketing",
        },
        ctas: [
            {
                label: { ja: "Instagramを見る", en: "View Instagram" },
                url: "https://www.instagram.com/hayashi_seimen_eu/",
            },
        ],
        serviceTags: ["sns", "translation", "localization"],
        purposeTags: ["brand"],
        requestBackground: {
            ja: "ドイツをはじめとするヨーロッパ各国のレストランやカフェ向けに、麺の卸販売事業を展開したい。自社のこだわりなどをSNSでアピールし、認知度を上げたい。",
            en: "The client wanted to expand their wholesale noodle sales business to restaurants and cafes in Germany and other European countries. They also wanted to promote their company’s unique qualities on social media to increase brand awareness.",
        },
        release: {
            ja: "2024年12月",
            en: "December 2024",
        },
    },

    {
        slug: "marukinkaraageLp",
        category: "LP",
        thumbnail: marukinkaraageLp,
        title: {
            ja: "Marukinkaraage | LP",
            en: "Marukinkaraage | LP",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://dae-yang.online/ja/pages/marukin-karaage",
            },
        ],
        client: {
            name: {
                ja: "Marukinkaraage",
                en: "Marukinkaraage",
            },
        },
        industryTags: ["restaurant"],
        company: { country: "germany" },
        overview: {
            ja: "ドイツで初の唐揚げ専門店。",
            en: "Germany's first fried chicken specialty store.",
        },
        serviceTags: ["lp"],
        target: { regions: [], countries: ["germany"] },
        purposeTags: ["brand"],
        requestBackground: {
            ja: "店舗の認知向上のために、メニューなどを掲載したWebサイトが欲しい。",
            en: "The client wanted a website to showcase menus and improve store recognition.",
        },
        release: {
            ja: "2023年8月",
            en: "August 2023",
        },
        website: "https://dae-yang.online/ja/pages/marukin-karaage",
        images: [marukinkaraageLpMock],
        webImages: {
            pc: marukinkaraageLpPc,
            sp: marukinkaraageLpSp,
        },
    },

    {
        slug: "orenorheingawaBlog",
        category: "Blog",
        thumbnail: orenorheingawaBlog,
        title: {
            ja: "俺のライン川 | ブログ",
            en: "Orenorehingawa | Blog",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://orenorhinegawa.blog/",
            },
        ],
        client: {
            name: {
                ja: "俺のライン川",
                en: "Orenorehingawa",
            },
        },
        industryTags: ["webService"],
        company: { country: "germany" },
        overview: {
            ja: "ドイツの情報を発信するブログサイト。",
            en: "A blog site that shares information about Germany.",
        },
        serviceTags: ["blog"],
        target: { regions: ["europe"], countries: [] },
        purposeTags: ["informationSharing"],
        requestBackground: {
            ja: "ドイツの情報を広めたい。",
            en: "The client wanted to spread information about Germany.",
        },
        release: {
            ja: "2024年6月",
            en: "June 2024",
        },
        website: "https://orenorhinegawa.blog/",
    },

    {
        slug: "amesankohjpCorporate",
        category: "Corporate",
        thumbnail: amesankohjpCorporate,
        title: {
            ja: "Amesankoh | コーポレートサイト",
            en: "Amesankoh | Corporate Website",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://www.amesankoh.co.jp/",
            },
        ],
        client: {
            name: {
                ja: "Amesankoh",
                en: "Amesankoh",
            },
        },
        industryTags: ["it", "consulting"],
        company: { country: "japan" },
        overview: {
            ja: "日本のデロイト出身者が創業のコンサル会社。",
            en: "A consulting firm founded by former Deloitte Japan employees.",
        },
        serviceTags: ["corporate"],
        target: { regions: [], countries: ["japan"] },
        purposeTags: ["inquiry"],
        requestBackground: {
            ja: "企業の認知向上と、問い合わせを受けるためのwebサイトが欲しい。",
            en: "The client wanted a website to improve company recognition and receive inquiries.",
        },
        release: {
            ja: "2023年8月",
            en: "August 2023",
        },
        website: "https://www.amesankoh.co.jp/",
        images: [amesankohjpCorporateMock],
        webImages: {
            pc: amesankohjpCorporatePc,
            sp: amesankohjpCorporateSp,
        },
    },

    {
        slug: "tagawaTote",
        category: "Product",
        clientId: "tagawa",
        thumbnail: tagawaTote,
        title: {
            ja: "田川 | ロゴ | 商品制作",
            en: "Tagawa | Logo & Production",
        },
        serviceTags: ["product", "logo", "print"],
        purposeTags: ["brand"],
        requestBackground: {
            ja: "会社名のPRを目的とした商品を制作したい。",
            en: "The client wanted to create products for the purpose of promoting the company name.",
        },
        release: {
            ja: "2024年9月",
            en: "September 2024",
        },
        images: [tagawaToteImg01],
    },

    {
        slug: "ramennobuUniform",
        category: "Uniform",
        thumbnail: ramennobuUniform,
        title: {
            ja: "RAMEN NOBU | ユニフォーム",
            en: "RAMEN NOBU | Uniform",
        },
        client: {
            name: {
                ja: "RAMEN NOBU",
                en: "RAMEN NOBU",
            },
        },
        industryTags: ["restaurant"],
        company: { country: "belgium" },
        overview: {
            ja: "ベルギーのラーメン店。",
            en: "A ramen shop in Belgium.",
        },
        serviceTags: ["uniform", "print"],
        target: { regions: [], countries: ["belgium"] },
        purposeTags: ["brand"],
        requestBackground: {
            ja: "スタッフ用のユニフォームを作成して、ブランドイメージの向上をはかりたい。",
            en: "The client wanted to create staff uniforms to enhance the brand image.",
        },
        release: {
            ja: "2024年9月",
            en: "September 2024",
        },
        website: "https://www.ramennobu.com/",
        images: [ramennobuUniformImg01],
    },

    {
        slug: "eurojcupTote",
        category: "Novelty",
        thumbnail: eurojcupTote,
        title: {
            ja: "EURO J CUP | ノベルティ",
            en: "EURO J CUP | Novelty",
        },
        client: {
            name: {
                ja: "EURO J CUP",
                en: "EURO J CUP",
            },
        },
        industryTags: ["event"],
        company: {
            country: "germany",
        },
        overview: {
            ja: "2024年にデュッセルドルフで開催された、日本人チームによるサッカー大会。",
            en: "A soccer tournament held in Düsseldorf in 2024, organized by a Japanese team.",
        },
        serviceTags: ["novelty", "print"],
        target: {
            countries: ["germany"],
        },
        purposeTags: ["brand"],
        requestBackground: {
            ja: "大会の認知度向上と企業・イベントブランディングを目的としたノベルティを制作したい。",
            en: "The client wanted to create promotional items to increase event recognition and strengthen branding.",
        },
        release: {
            ja: "2024年6月",
            en: "June 2024",
        },
        images: [eurojcupToteImg01, eurojcupToteImg02],
    },

    {
        slug: "imoriichibaTote",
        category: "Product",
        clientId: "imoriichiba",
        thumbnail: imoriichibaTote,
        title: {
            ja: "IMORI ICHIBA | トートバッグ",
            en: "IMORI ICHIBA | Totebag",
        },
        serviceTags: ["product", "print"],
        purposeTags: ["brand"],
        requestBackground: {
            ja: "ブランド認知向上と企業アピールを目的としたトートバッグを制作したい。",
            en: "The client wanted to create tote bags to enhance brand awareness and promote the company.",
        },
        release: {
            ja: "2024年6月",
            en: "June 2024",
        },
        images: [imoriichibaToteImg01, imoriichibaToteImg02, imoriichibaToteImg03],
    },

    {
        slug: "alfaManagementCorporate",
        category: "Corporate",
        thumbnail: alfaManagementCorporate,
        title: {
            ja: "ALFA-Management UG | サイト改修",
            en: "ALFA-Management UG | Website Redesign",
        },
        ctas: [
            {
                label: { ja: "Webサイトを見る", en: "View Website" },
                url: "https://alfa-management.com/",
            },
        ],
        client: {
            name: { ja: "ALFA-Management UG", en: "ALFA-Management UG" },
        },
        industryTags: ["consulting"],
        company: { country: "germany" },
        overview: {
            ja: "ドイツ・デュッセルドルフを拠点に企業＆アスリートをサポートする企業。",
            en: "A company based in Düsseldorf, Germany, supporting businesses and athletes.",
        },
        serviceTags: ["websiteRedesign", "translation"],
        target: { regions: ["europe"], countries: [] },
        purposeTags: ["brand"],
        requestBackground: {
            ja: "サイトコンテンツの修正と、多言語対応のための翻訳ページを作成したい。",
            en: "The client wanted to modify website content and create a translation page.",
        },
        release: {
            ja: "2024年10月",
            en: "October 2024",
        },
    },
];



export const resolveWork = (work) => {
    if (!work.clientId) return work;

    const c = clients[work.clientId];
    if (!c) return work;

    return {
        ...work,
        client: { name: c.name },
        company: work.company ?? c.company,
        target: work.target ?? c.target,
        industryTags: work.industryTags ?? c.industryTags,
        website: work.website ?? c.website,
        overview: work.overview ?? c.overview,
        requestBackground: work.requestBackground ?? c.requestBackground,
        release: work.release ?? c.release,
    };
};
